/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeProfileIndex = 'route-profile-index',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).profile._index',
	profile = 'routes/($lang).profile',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as PROFILE_INDEX_I18NEXT,
	ROUTE_LOADER as PROFILE_INDEX_ROUTE_LOADER,
}
